export default "__VITE_ASSET__DoXL01o9__"